import {TimelineEntry} from './TimelineEntry';

export class TimelineWaitlistedEntry extends TimelineEntry {

    constructor(public key: string, public startDate: Date) {
        super(key, 'Waitlisted', startDate, true);
    }

    getColor(): string {
        return '#801218';
    }

}
